import ElapsedTime from "@lib/common/components/ElapsedTime/ElapsedTime";
import ShimmerText from "@lib/common/components/ShimmerText/ShimmerText";
import { Group, Loader, Tooltip } from "@mantine/core";

/** The in-flight progress update: loader, shimmering progress line, how far along, and how long it's been running. */
export default function ActiveStatusItem({ label, startedAt }: { label: string; startedAt: Date }) {
  return (
    <Tooltip label="Deep research">
      <Group flex={1} miw={0} gap={10} wrap="nowrap">
        <Loader size="xs" style={{ flexShrink: 0 }} />
        <ShimmerText size="sm" lh={1} truncate miw={0}>
          {label}
        </ShimmerText>
        <ElapsedTime since={startedAt} size="sm" c="dimmed" style={{ whiteSpace: "nowrap" }} />
      </Group>
    </Tooltip>
  );
}
